import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { AdminPracticeBaseQueryDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminPracticeBaseQueryResultFragment, AdminPracticeBaseQueryParams } from '@docpace/admin-graphql'

const typedAdminPracticeBaseQueryDocument = AdminPracticeBaseQueryDocument as TypedDocumentNode<AdminPracticeBaseQueryResultFragment, Partial<AdminPracticeBaseQueryParams>>

export function useAdminPracticeBaseQuery(opts?: useQuery.Options<AdminPracticeBaseQueryResultFragment, Partial<AdminPracticeBaseQueryParams>>){
    return useQuery(typedAdminPracticeBaseQueryDocument, opts)
}
